// extracted by mini-css-extract-plugin
export default {"label":"TextWithLabel_label__SUN2m","text":"TextWithLabel_text__qqNeb"};